<template>
  <div class="main">
    <div style="height:10px;background:#f2f2f2"></div>
    <div class="textMain">
      <div class="textTil">{{problemInfo.fTitle}}</div>
      <div class="textDate">发布日期：{{problemInfo.adddate}}</div>
      <div class="textCont" v-html="problemInfo.fContent"></div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { addBaseAplus } from '../utils/zzdmd.js'
export default {
  name: 'problemDetail',
  data () {
    return {
      id:this.$route.query.id,
      problemInfo:''
    }
  },
  created(){
    this.id = this.$route.query.id
    this.getProblemInfo()
  },
  mounted(){
    addBaseAplus(this.$route)
  },
  activated(){
    this.id = this.$route.query.id
    this.getProblemInfo()
  },
  methods:{
    getProblemInfo(){
      let param = {
         FeedbackID:this.id
      }
       this.$post('api/ProblemBase/GetProblemBaseInfo', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          this.problemInfo = res.data
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .textMain{
    width: 100%;
    background: #fff;
    box-sizing: border-box;
    padding: 23px 12px;
  }
  .textTil{
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }
  .textDate{
    font-size: 12px;
    font-weight: 500;
    color: #666666;
    margin: 10px 0;
  }
  .textCont{
    margin-top: 18px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/page/problemDetail.vue